import type { ArrowDirection } from '../components/atomic/buttons/arrows/Arrows';
import type { NavBarTab } from '../components/composite/nav/nav_bar/NavBar';
import {
  closeInfoPopup,
  toggleInfoPopup,
} from '../shared/infoPopup/infoPopupControllerActions';
import { nextPageForDirection } from '../shared/pagination/clampPageChange';
import {
  MAX_STICKER_PAGE,
  type StickersScreenModel,
} from './StickersScreenModelScreen';

export class StickersScreenController {
  constructor(private readonly model: StickersScreenModel) {}

  handleNavigate = (direction: ArrowDirection) => {
    this.model.setPage((current) =>
      nextPageForDirection(direction, current, MAX_STICKER_PAGE),
    );
    this.model.onNavigate?.(direction);
  };

  handleInfoButtonClick = () => {
    toggleInfoPopup(this.model);
  };

  handleInfoClose = () => {
    closeInfoPopup(this.model);
  };

  handleTabChange = (tab: NavBarTab) => {
    this.model.onTabChange?.(tab);
  };
}
